const passHelpers = {
	getTemplate(pass, template) {
		if(pass.template_id === template.id)
			return template;

		return (template.childTemplates || []).find(x => x.id === pass.template_id);
	},

	saveChanges: (isSaving, partner, pass, returnUrl) => {
		isSaving = true;
		let url = `/partner-portal/${partner.id}/passes/save-pass/${pass.id ||
		''}`;

		axios.put(url, pass)
				.then(response => {
					window.EventBus.$emit('system-messages', [
						{
							message: 'Pass ' + (pass.id ? 'updated' : 'created') +
									' - redirecting now...',
							messageType: 'success',
							showOverlay: true
						}
					]);
					setTimeout(() => {
						window.location = returnUrl;
					}, 2000);
				})
				.catch(error => {
					isSaving = false;
					window.EventBus.$emit('system-messages', [
						{ message: error.message, messageType: 'error' }
					]);
				});
	},

	getReturnUrl: (returnUrl, partner) => {
		return returnUrl || `/partner-portal/${partner.id}/passes`;
	},

	getValidationRules: (data) => ({
		template_id: [v => !!v || 'You must choose a coupon template.'],
		name: [v => !!v || 'Name is required.'],
		mobile_pass_description: [v => !!v || 'Description is required.'],
		kickoff_date: [v => !!v || 'Kickoff date is required.'],
		launch_date: [v => !!v || 'Launch date is required.'],
		media: [v => !!v || 'Image is required.'],
		short_description: [v => !!v || 'Learn More Description is required.'],
		highlights: [v => !!v || 'Highlights are required.'],
		redemption_start: [v => !!v || 'Redemption Start Date is required.'],
		redemption_end: [v => !!v || 'Redemption End Date is required.'],
		redemption_start_type: [v => !!v || 'Redemption start type is required.'],
		redemption_ends_amount: [v => !!v || 'Redemption ends amount is required.'],
		redemption_ends_type: [v => !!v || 'Redemption end type is required.'],
		redemption_ends_date: [v => !!v || 'Redemption end date is required.'],
		redemption_start_date: [v => !!v || 'Redemption start date is required.'],
		requirement_product_template: [v => !!v || 'Product template is required.'],
		requirement_product_title: [v => !!v || 'Product title is required.'],
	}),

	getRedemptionPolicyObject: (pass) => {
		return {
			activation_type: pass?.redemption_policy?.activation_type || null,
			expires: {
				days: pass?.redemption_policy?.expires?.days || null,
				type: pass?.redemption_policy?.expires?.type || null,
				date: pass?.redemption_policy?.expires?.date || null
			},
			start_date: pass?.redemption_policy?.start_date || null,
			ends: {
				amount: pass?.redemption_policy?.ends?.amount || null,
				type: pass?.redemption_policy?.ends?.type || null,
				date: pass?.redemption_policy?.ends?.date || null
			}
		};
	},

	getPassHighlights: () => {
		return 'Mobile exclusive\nInstantly delivered via text and email\nNo apps to download'
	},

	productRequirementsErrorMessages: (newPass) => {
		const errorMessages = [];
		for (const k in newPass.productTemplates) {
			const productTemplate = newPass.productTemplates[k];
			if(productTemplate.min > 0) {
				let reqs = [];
				if(newPass.onboard_settings) {
					reqs = newPass.onboard_settings.productReqs.filter((pr) => pr.product_template_type === productTemplate.type);
				}
				if(reqs.length < productTemplate.min) {
					errorMessages.push(`You must add at least ${productTemplate.min} ${productTemplate.name} requirement(s).`);
				}
			}
		}
		return errorMessages;
	},

	getAwardPoinsOnRedemptionRule: (pass, extraData) => {
		if(pass.r_rules && pass.r_rules.length > 0) {
			const rules = [];
			pass.r_rules.forEach((rule) => {
				if(rule.pivot.rule_id === extraData.ruleAwardPointsOnRedemptions.id) {
					rules.push({
						id: rule.pivot.id,
						deal_id: rule.pivot.deal_id,
						rule_id: rule.pivot.rule_id,
						settings: rule.pivot.settings
					});
				}
			});
			return rules;
		}
		else {
			return [
				{
					id: null,
					deal_id: pass.id,
					rule_id: extraData.ruleAwardPointsOnRedemptions.id,
					settings: {
						"product_ids": [],
						"product_options": [],
						"end_dates": [],
						"redemptions_needed": 1,
						"max_sends": 1,
						"display_on_pass": "visible"
					}
				}
			];
		}

	},
};

const savingsHelpers = {

	getValidationRules: (data) => ({
		...passHelpers.getValidationRules(data),
	}),

};

const checkinHelpers = {

	getValidationRules: (data) => ({
		...passHelpers.getValidationRules(data),
		validation_type: [v => !!v || 'Validation Type is required.'],
	}),

};

const culinaryHelpers = {

	getValidationRules: (data) => ({
		...passHelpers.getValidationRules(data),
		validation_type: [v => !!v || 'Validation Type is required.'],
	}),

};

const admissionHelpers = {

	getValidationRules: (data) => ({
		...passHelpers.getValidationRules(data),
		retail_price: [
			v => !!v || 'Retail Price is required.',
			v => v > 0 || 'Retail Price should be greater than 0.'
		],
		paid_on_override: [v => !!v || 'Paid On Override is required.'],
	}),

};


const tastingHelpers = {

	getValidationRules: (data) => ({
		...passHelpers.getValidationRules(data),
		retail_price: [
			v => !!v || 'Retail Price is required.',
			v => v > 0 || 'Retail Price should be greater than 0.'
		],
		paid_on_override: [v => !!v || 'Paid On Override is required.'],
	}),

};

export {
	savingsHelpers,
	checkinHelpers,
	culinaryHelpers,
	admissionHelpers,
	tastingHelpers,
	passHelpers
};
